import { GetHistoryRequest, OddsEntry } from '@img-arena/consoles-api-golf-pricing'
import { golfPricingApi } from '@/service/golfPricingApi'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'

export const fetchApi = async (
  args: FetchApiArgs<GetHistoryRequest, string, string>
): Promise<FetchApiResponse<OddsEntry>> => {
  const { additionalParams, signal } = args

  const { data } = await golfPricingApi.endpoints.odds.getHistory(additionalParams, signal)

  return {
    content: data.oddsEntries,
    totalElements: data.oddsEntries.length
  }
}

export const useOddsHistoryStore = createBaseTableStore({
  storeName: 'DDE Golf Pricing - Odds History',
  fetchApi
})
